import { defineComponent, ref, provide } from 'vue';
import { POPPER_INJECTION_KEY } from './tokens.mjs';

var script = defineComponent({
  name: "ElPopperProvider",
  inheritAttrs: false,
  setup() {
    const popperProvides = {
      triggerRef: ref(null),
      popperInstanceRef: ref(null),
      contentRef: ref(null)
    };
    provide(POPPER_INJECTION_KEY, popperProvides);
    return popperProvides;
  }
});

export { script as default };
//# sourceMappingURL=popper.vue_vue_type_script_lang.mjs.map
